module.exports = __webpack_public_path__ + "media/images/emblems/Roggwil_TG-coat_of_arms-4a944f3272aad92ccfbe325984abd7b4.svg";